// ***********************************
// API.vue
// ***********************************
<template>
  <div id="app">
    <div class="container">
      <b-alert :show="showAlert" :variant="alertStyle">{{alertText}}</b-alert>
      <b-card v-if="!showAlert" header="API: API and MCP Server Access"> 
        <b-list-group>
          <b-list-group-item>
            <div>
              <p>
              <b>DBCSI now offers an API as well as a MCP Server.</b>
              </p>
              
              <p>
              <b>This is a work-in-progress, with an initial limited set of API and MCP tools.  More features will be coming soon.</b>
              </p>

              <p>
              <b>Please send feedback to dbayard@amazon.com</b>
              </p>
              
            </div>
          </b-list-group-item>
          <b-list-group-item>
            <div>
              
                          <div style="margin: 15px">
                            <p style="font-size:14px">To invoke the DBCSI API and/or DBCSI MCP Server, you will need a user-specific API Key.  You can use this page to generate your API Key or to rotate your existing API Key to a new one.  The API Key will be specific to your DBCSI user.
                              To continue, please read and acknowledge the following:</p>
                            <br/>
                            <p style="font-size:14px"><b>API Key Acknowledgement:</b>  Anyone who has been given your generated API Key and knows your DBCSI username will be able to invoke the DBCSI APIs and see your uploaded DBCSI information.  Please protect your API Key.  If you already have an API Key for your DBCSI username, clicking the below button will create a new Key and render the previous one unusable.</p>
                            

                            <b-form>
                              
                                   
                              <b-form-group
                                id="exampleInputGroup0"
                                label="Generated DBCSI API Key:"
                                label-for="getKey"
                                description="Please copy the above API Key and use it invoke the DBCSI APIs or DBCSI MCP Server."
                                v-if="generatedAPIKey !=''"
                              >
                                <b-form-input
                                  id="genKey"
                                  type="text"
                                  v-model="generatedAPIKey"
                                  required
                                  disabled
                                  placeholder="generated DBCSI API Key for your username"
                                ></b-form-input>
                              </b-form-group>
                              
                              <b-button @click="generateKey(0)" v-if="(generatedAPIKey=='')" variant="success">Acknowledge Above and Generate New API Key (replacing any old key)</b-button>
                            </b-form>
                      </div> 
                      

            </div>
          </b-list-group-item>
          <b-list-group-item>
            <div>
              <b>To get started with the DBCSI MCP Server...</b>
              <b-card bg-variant="light" class="text-left" >
                <pre>
The DBCSI MCP server exposes these tools:

Data Retrieval
- get_collections — List all databases (collections) accessible to the user (up to 1000)
- get_batches — List all batches accessible to the user (up to 1000)
- get_batch_databases — List the individual databases within a specific batch

Sizing & Analysis
- calculate_target_values — Calculate the 5 sizing dimensions (VCPU, Memory, IOPS, Throughput, DiskSpace)
      from a collection's uploaded AWR/STATSPACK metrics, using configurable algorithms (cpu_algo, iops_algo, etc.)
- calculate_target_values_from_summary — Calculate the 5 sizing dimensions from precalculated summary values
      (such as DB_CPU_THREADS_AVERAGE_P99 from the OS-INFORMATION section of an aws_awr_miner.sql output file),
      without needing a collection ID or uploading anything to DBCSI

Shape Selection & Pricing
- get_rds_shapes — Get available shapes with specs and pricing for RDS-Oracle, Aurora PostgreSQL, and EC2
- pick_rds_shape — Find the best-fit RDS shape for given target values and preferences
- configure_rds_shape — Build and price a complete RDS configuration (compute + EBS storage) for a specific shape
- pick_aurora_shape — Find the best-fit Aurora shape for given target values and preferences
- configure_aurora_shape — Build and price a complete Aurora configuration (compute + storage) for a specific shape
- pick_ec2fsxn_shape — Find the best-fit EC2 shape (for FSxN storage) for given target values and preferences
- configure_ec2fsxn_shape — Build and price a complete EC2 + FSx for NetApp ONTAP configuration for a specific shape
- configure_odb_dedicated — Build and price a complete dedicated ODB configuration (infrastructure + usage)
- configure_odb_exascale — Build and price a complete exascale ODB configuration (infrastructure + usage) 
- configure_odb_serverless — Build and price a complete ODB serverless configuration (infrastructure + usage) 

Data Upload
- upload_collection — Upload a single AWR/STATSPACK miner output file 
- upload_batch — Upload a batch zip file containing multiple database collection files 

Batch Management
- create_batch_from_collections — Create a new batch by specifying a list of existing collection IDs (databases)
- update_batch — Update an existing batch's attributes (customer, batchname, descr) and/or its list of databases

Sharing
- share_batch_to_user — Share a batch to a specific DBCSI user (by userID or email address)
- share_batch_via_url — Share a batch by creating a publicly accessible URL for other DBCSI users

Charting and Metrics Retrieval
- get_available_metrics - get a list of metrics that are available for a given database (collection)
- get_metric_data - get metric data for a given database(collection) and metric
- generate_chart - generate a chart using DBCSI charting routines

                  
                </pre>


                <p>To install/setup the DBCSI MCP server, follow these steps:</p>
                <p>1. Setup your MCP client, such as Kiro CLI.</p>
                <p>2. Ensure that <code>uvx</code> is available on your workstation:
                <div style="margin-left: 40px;">On macOS and Linux, you can use <code>curl -LsSf https://astral.sh/uv/install.sh | sh</code></div>
                <div style="margin-left: 40px;">On Windows, you can try <code>powershell -ExecutionPolicy ByPass -c "irm https://astral.sh/uv/install.ps1 | iex"</code></div></p>
                <p>3. Add the following snippet to your ~/.kiro/settings/mcp.json (for clients other than Kiro CLI, choose the appropriate file)</p>
                <pre><code>
{
  "mcpServers": {
    "dbcsi-mcp": {
      "command": "uvx",
      "args": [
        "--from",
        "https://dbcsi.d29q8g3b9hzyur.amplifyapp.com/dbcsi_mcp_server.zip",
        "dbcsi-mcp-server"
      ],
      "disabled": false,
      "env": {
        "dbcsi_username": "{{this.user}}",
        "dbcsi_userkey": "{{this.generatedAPIKey}}",
        "API_GW_URL": "https://zvpj0w4ua1.execute-api.us-east-1.amazonaws.com/prod",
        "API_GW_KEY": "save_for_later"
      },
      "autoApprove": []
     }
  }
}
                </code></pre>
                <p>4. Edit the "dbcsi_username" value with your actual DBCSI username (this should already be populated).</p>
                <p>5. Edit the "dbcsi_userkey" value with your DBCSI API Key (this should already be populated, once you click the Acknowledge button above).</p>
                <p>6. Start or restart Kiro CLI.</p>
                <p>7. Try this sample prompt: </p>
                <p><b>Can you configure an rds-oracle shape for Standard Edition2 License Included using Multi-AZ that has at least 3 VPCU, 8 GB of memory, 1000 GB of storage, and can do 1000 MB/s and 5000 IOPS of IO?</b></p>
                <p>8. Another sample prompt (you should first create a file "databases.csv" such as this <a
                  href="/databases.csv" target="_blank"
                >example</a>): </p>
                <p><b>Using the databases in databases.csv, configure an RDS-Oracle Enterprise Edition shape for each database and create a new spreadsheet with all the details.</b></p>
                <p>9. Or try these sample prompts to run the auto-right-sizer against one of the <a
                  href="https://dbcsi.d29q8g3b9hzyur.amplifyapp.com/batch/C459" target="_blank"
                >sample databases</a>: </p>
                <p><b>I want to use DBCSI to calculate target values for a database collection.  First, can you tell me the different algorithm choices for calculating the CPU target value? </b></p>
                <p>followed by...</p>
                <p><b>Can you calculate target values for DBCSI dataabse collectionID 459 using the cpu3 algorithm to calculate the CPU?</b></p>
                <p>followed by...</p>
                <p><b>Using those target values, can you configure an rds-oracle shape using Enterprise Edition(BYOL) and MultiAZ?</b></p>

                <b-button v-b-toggle.collapse-section variant="outline-primary" size="sm" class="mt-2">
                  View Sample Output
                </b-button>
                <b-collapse id="collapse-section" class="mt-2">
                  <b-card>
<pre style="font-size: 7pt;">
$ kiro-cli
○ dbcsi-mcp is disabled
✓ dbcsi-mcp-local loaded in 1.06 s
⚠ 1 of 2 mcp servers initialized. Servers still loading:
 - aws-mcp
⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀     ⢀⣴⣶⣶⣦⡀⠀⠀⠀⢀⣴⣶⣦⣄⡀⠀⠀⢀⣴⣶⣶⣦⡀⠀⠀⢀⣴⣶⣶⣶⣶⣶⣶⣶⣶⣶⣦⣄⡀⠀⠀⠀⠀⠀⠀⢀⣠⣴⣶⣶⣶⣶⣶⣦⣄⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀    ⢰⣿⠋⠁⠈⠙⣿⡆⠀⢀⣾⡿⠁⠀⠈⢻⡆⢰⣿⠋⠁⠈⠙⣿⡆⢰⣿⠋⠁⠀⠀⠀⠀⠀⠀⠀⠀⠈⠙⠻⣦⠀⠀⠀⠀⣴⡿⠟⠋⠁⠀⠀⠀⠈⠙⠻⢿⣦⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀    ⢸⣿⠀⠀⠀⠀⣿⣇⣴⡿⠋⠀⠀⠀⢀⣼⠇⢸⣿⠀⠀⠀⠀⣿⡇⢸⣿⠀⠀⠀⢠⣤⣤⣤⣤⣄⠀⠀⠀⠀⣿⡆⠀⠀⣼⡟⠀⠀⠀⠀⣀⣀⣀⠀⠀⠀⠀⢻⣧⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀    ⢸⣿⠀⠀⠀⠀⣿⡿⠋⠀⠀⠀⢀⣾⡿⠁⠀⢸⣿⠀⠀⠀⠀⣿⡇⢸⣿⠀⠀⠀⢸⣿⠉⠉⠉⣿⡇⠀⠀⠀⣿⡇⠀⣼⡟⠀⠀⠀⣰⡿⠟⠛⠻⢿⣆⠀⠀⠀⢻⣧⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀    ⢸⣿⠀⠀⠀⠀⠙⠁⠀⠀⢀⣼⡟⠁⠀⠀⠀⢸⣿⠀⠀⠀⠀⣿⡇⢸⣿⠀⠀⠀⢸⣿⣶⣶⡶⠋⠀⠀⠀⠀⣿⠇⢰⣿⠀⠀⠀⢰⣿⠀⠀⠀⠀⠀⣿⡆⠀⠀⠀⣿⡆
⠀⠀⠀⠀⠀⠀⠀    ⢸⣿⠀⠀⠀⠀⠀⠀⠀⠀⠹⣷⡀⠀⠀⠀⠀⢸⣿⠀⠀⠀⠀⣿⡇⢸⣿⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣠⣼⠟⠀⢸⣿⠀⠀⠀⢸⣿⠀⠀⠀⠀⠀⣿⡇⠀⠀⠀⣿⡇
⠀⠀⠀⠀⠀⠀⠀    ⢸⣿⠀⠀⠀⠀⠀⣠⡀⠀⠀⠹⣷⡄⠀⠀⠀⢸⣿⠀⠀⠀⠀⣿⡇⢸⣿⠀⠀⠀⠀⣤⣄⠀⠀⠀⠀⠹⣿⡅⠀⠀⠸⣿⠀⠀⠀⠸⣿⠀⠀⠀⠀⠀⣿⠇⠀⠀⠀⣿⠇
⠀⠀⠀⠀⠀⠀⠀    ⢸⣿⠀⠀⠀⠀⣾⡟⣷⡀⠀⠀⠘⣿⣆⠀⠀⢸⣿⠀⠀⠀⠀⣿⡇⢸⣿⠀⠀⠀⠀⣿⡟⣷⡀⠀⠀⠀⠘⣿⣆⠀⠀⢻⣧⠀⠀⠀⠹⣷⣦⣤⣤⣾⠏⠀⠀⠀⣼⡟
⠀⠀⠀⠀⠀⠀⠀    ⢸⣿⠀⠀⠀⠀⣿⡇⠹⣷⡀⠀⠀⠈⢻⡇⠀⢸⣿⠀⠀⠀⠀⣿⡇⢸⣿⠀⠀⠀⠀⣿⡇⠹⣷⡀⠀⠀⠀⠈⢻⡇⠀⠀⢻⣧⠀⠀⠀⠀⠉⠉⠉⠀⠀⠀⠀⣼⡟
⠀⠀⠀⠀⠀⠀⠀    ⠸⣿⣄⡀⢀⣠⣿⠇⠀⠙⣷⡀⠀⢀⣼⠇⠀⠸⣿⣄⡀⢀⣠⣿⠇⠸⣿⣄⡀⢀⣠⣿⠇⠀⠙⣷⡀⠀⠀⢀⣼⠇⠀⠀⠀⠻⣷⣦⣄⡀⠀⠀⠀⢀⣠⣴⣾⠟
⠀⠀⠀⠀⠀⠀⠀    ⠀⠈⠻⠿⠿⠟⠁⠀⠀⠀⠈⠻⠿⠿⠟⠁⠀⠀⠈⠻⠿⠿⠟⠁⠀⠀⠈⠻⠿⠿⠟⠁⠀⠀⠀⠈⠻⠿⠿⠟⠁⠀⠀⠀⠀⠀⠈⠙⠻⠿⠿⠿⠿⠟⠋⠁

╭─────────────────────────────── Did you know? ────────────────────────────────╮
│                                                                              │
│     Enable workspace checkpoints to snapshot & restore changes. Just run     │
│                 kiro-cli settings chat.enableCheckpoint true                 │
│                                                                              │
╰──────────────────────────────────────────────────────────────────────────────╯

Model: Auto (/model to change)


> /tools


Tool                                 Permission
▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔
Built-in
- shell                              not trusted
- read                               trust working directory
- write                              not trusted
- introspect                         trusted
- report                             not trusted
- aws                                trust read-only commands
- web_fetch                          not trusted
- web_search                         not trusted

aws-mcp (MCP)
- aws___call_aws                     not trusted
- aws___get_regional_availability    not trusted
- aws___list_regions                 not trusted
- aws___read_documentation           not trusted
- aws___recommend                    not trusted
- aws___retrieve_agent_sop           not trusted
- aws___search_documentation         not trusted
- aws___suggest_aws_commands         not trusted

dbcsi-mcp-local (MCP)
- calculate_target_values            not trusted
- configure_rds_shape                not trusted
- get_rds_shapes                     not trusted
- pick_rds_shape                     not trusted



> I want to use DBCSI to calculate target values for a database collection.  First, can you tell me the different algorithm choices for calculating the 
CPU target value?

> Based on the DBCSI tool, here are the different algorithm choices for calculating the CPU target value:

CPU Algorithm Options (cpu_algo):
- cpu1 - P99 of averages
- cpu2 - P90 of peaks  
- cpu3 - Larger of P99 averages OR P90 peaks (default)
- cpu4 - Larger of P99 averages OR P97 peaks
- cpu5 - P75 of averages

Buffer Options:
You can add a 10% buffer to any of these algorithms by appending _plus10:
- cpu1_plus10, cpu2_plus10, cpu3_plus10, cpu4_plus10, cpu5_plus10

The default algorithm is cpu3, which takes the larger value between the 99th percentile of average CPU usage and the 90th percentile of peak CPU usage. 
This provides a balanced approach that accounts for both sustained workload patterns and peak demand spikes.

When you're ready to calculate target values, you'll need to provide a collection ID and can specify your preferred CPU algorithm along with other 
calculation preferences.
 ▸ Time: 6s

> Can you calculate target values for collectionID 459 using the cpu3 algorithm to calculate the CPU?

Running tool calculate_target_values with the param (from mcp server: dbcsi-mcp-local)
 ⋮  {
 ⋮    "collection_id": "459",
 ⋮    "prefs": {
 ⋮      "cpu_algo": "cpu3"
 ⋮    }
 ⋮  }

Allow this action? Use 't' to trust (always allow) this tool for the session. [y/n/t]:

> y

 - Completed in 6.904s

> The target values have been successfully calculated for collection ID 459 using the cpu3 algorithm. Here are the results:

Target Values Summary:
- **VCPU**: 20.6
- **Memory**: 300 GB
- **IOPS**: 10,272
- **Throughput**: 3,781 MB/s
- **Disk Space**: 34,479 GB

Key Details:
- This is an Exadata database with 4 instances
- Original database size: 29,982 GB
- Platform: Linux x86_64-bit

Algorithm Adjustments Made:
- **CPU**: Used cpu3 algorithm (larger of P99 averages OR P90 peaks). Original target was 18.0 VCPUs, increased to 20.6 due to expected SmartScan workload
- **Memory**: Increased from original 80 GB to 300 GB to help with post-Exadata transition
- **IOPS**: Reduced from 30,816 to 10,272 using moderate post-Exadata SmartScan tuning assumptions
- **Throughput**: Reduced from 11,344 MB/s to 3,781 MB/s using moderate post-Exadata SmartScan tuning assumptions

The calculation assumes moderate tuning for post-Exadata migration and optimizes for minimizing Oracle licensing costs by reducing VCPUs where possible.
 ▸ Time: 23s

> Using those target values, can you configure an rds-oracle shape using Enterprise Edition(BYOL) and MultiAZ?

> I need to first find the best RDS shape for your target values, then configure it. Let me start by finding the optimal shape:
Running tool pick_rds_shape with the param (from mcp server: dbcsi-mcp-local)
 ⋮  {
 ⋮    "region": "us-east-1",
 ⋮    "VCPU": 20.6,
 ⋮    "Memory": 300,
 ⋮    "DiskSpace": 34479,
 ⋮    "IOPS": 10272,
 ⋮    "Throughput": 3781,
 ⋮    "prefs": {
 ⋮      "rds_algo": "ee",
 ⋮      "multiAZ_algo": "Y"
 ⋮    }
 ⋮  }

Allow this action? Use 't' to trust (always allow) this tool for the session. [y/n/t]:

> y

 - Completed in 2.451s

> Now let me configure the RDS shape with your specifications:
Running tool configure_rds_shape with the param (from mcp server: dbcsi-mcp-local)
 ⋮  {
 ⋮    "Memory": 300,
 ⋮    "Throughput": 3781,
 ⋮    "VCPU": 20.6,
 ⋮    "DiskSpace": 34479,
 ⋮    "IOPS": 10272,
 ⋮    "region": "us-east-1",
 ⋮    "rds_shape": "db.r5b.6xlarge.tpc2.mem4x",
 ⋮    "prefs": {
 ⋮      "multiAZ_algo": "Y",
 ⋮      "rds_algo": "ee"
 ⋮    }
 ⋮  }

Allow this action? Use 't' to trust (always allow) this tool for the session. [y/n/t]:

> y

 - Completed in 1.853s

> Perfect! Here's your RDS Oracle Enterprise Edition (BYOL) configuration with MultiAZ:

## **RDS Configuration Summary**

Monthly Cost: $22,481.19 + 24 Oracle Processor Licenses

### **Compute Instance:**
- **Shape**: db.r5b.6xlarge.tpc2.mem4x
- **vCPUs**: 24 (meets your 20.6 requirement)
- **Memory**: 768 GB (exceeds your 300 GB requirement)
- **Processor**: Intel Xeon Platinum 8259CL (Cascade Lake) @ 3.1 GHz
- **MultiAZ**: Yes (provides high availability)
- **Monthly Compute Cost**: $13,901.10 (using 1-year Reserved Instance pricing)

### **Storage Configuration:**
- **Type**: gp3 (General Purpose SSD)
- **Size**: 34,479 GB
- **IOPS**: 15,124 (increased from your 10,272 requirement to support throughput)
- **Throughput**: 3,781 MB/s
- **Monthly Storage Cost**: $8,580.09

### **Oracle Licensing:**
- **License Type**: BYOL (Bring Your Own License)
- **Required Licenses**: 24 Oracle Processor Licenses total (accounts for both MultiAZ nodes)

### **Key Benefits:**
- Exceeds all your performance requirements
- MultiAZ deployment for high availability
- Cost-optimized with Reserved Instance pricing
- Additional capacity provides headroom for growth

The configuration automatically adjusted IOPS to 15,124 to meet the gp3 throughput requirements (gp3 requires IOPS ≥ 4x throughput in MB/s).
 ▸ Time: 28s

> 
</pre>
                  </b-card>
                </b-collapse>
                <p/>
                <p>10. Here are some more prompt ideas:</p>
                <p><b>What databases do I have in dbcsi? </b></p>
                <p><b>Can you show me my dbcsi batches? </b></p>
                <p><b>What databases are in batch 116? </b></p>
                <p><b>Upload the file /tmp/awr-hist-ORCL-1532353877-59633-59842.out to dbcsi for the customer "Test Customer" using the description "This is the ORCL database". </b></p>
                <p><b>Upload the batch of databases in /tmp/dbcsi_batch.zip to dbcsi for the customer "Test Customer" with batch name "TC-NonProd" and the description "Nonproduction databases". </b></p>

                <p/><p/>
                
              </b-card>
            </div>
          </b-list-group-item>
          <b-list-group-item>
            <div>
              <b>To get started with the DBCSI API...</b>
              <b-card bg-variant="light" class="text-left" >
                <p>Follow these steps:</p>
                <p>1. Download this zip file: <a
                  href="/dbcsi_mcp_server.zip" target="_blank"
                >dbcsi_mcp_server.zip</a></p>
                <p>2. Unzip the zip.</p>
                <p>3. Set the following environment variables:</p>
                <pre>
export dbcsi_username={{this.user}}
export dbcsi_userkey={{this.generatedAPIKey}}
export API_GW_KEY=save_for_later
export API_GW_URL=https://zvpj0w4ua1.execute-api.us-east-1.amazonaws.com/prod                  
                </pre>
                <p>4. Edit the "dbcsi_username" value with your actual DBCSI username (this should already be populated).</p>
                <p>5. Edit the "dbcsi_userkey" value with your DBCSI API Key (this should already be populated, once you click the Acknowledge button above).</p>
                <p>6. Invoke the dbcsi_api.py file to test the APIs and see them in action:</p>
                <pre>
python3 dbcsi_api.py                  
                </pre>
                <p>7. Import the various functions from dbcsi_api.py into your application.</p>
              </b-card>
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-card>
      

    </div>
  </div>
</template>    


<script>
import { API, Auth } from "aws-amplify";
export default {
  name: "app",
  props: [],
  data() {
    return {
      generatedAPIKey: '',
      user: '',
      selected: null,
      output_file: null,
      form: {
        also_allowed_id: "",
        batch_id: "0"
      },
      show: true,
      showAlert: false,
      alertText: "",
      alertStyle: "default",
      allowed_list: [
          { also_allowed_id: 'loading authorized user list...' },
      ],
      fields: [
        { key: 'also_allowed_id', label: 'DBCSI UserID' },
        { key: 'batch_name', label: 'Batch' },
        { key: 'batch_id', label: 'BatchID' },
        { key: 'actions', label: 'Action' }
      ],
      batch_list: [
        {
          batch_id: "3",
          status: "please wait",
          statusLong: "please wait",
          descr: "",
          batch_date: "",
          customer: "Loading Data...",
          num_dbs: ""
        }
      ],
      batchChoices: [
          { value: '0', text: 'Share ALL my databases' },
          { value: 'd', text: 'Loading your list of batches...', disabled: true }
      ]


      
    };
  },
  async created() {
    // console.log("Profile: I am here1");
    let name = await Auth.currentAuthenticatedUser();
    this.user = name.username;
  },
  methods: {
    async generateKey(theItem) {
      // console.log("generateKey", theItem.collectionID);

      this.generatedAPIKey = '';
      

      var batchParams = {
        body: {
          batchID: null
        }
      };
      

      await API.put(
        "dbcsiAPI",
        `/dbcsi/generateAPIKey`,
        batchParams
      )
        .then(response => {
          // success = true;
          // console.log("Batch- shareDatabases: put success");
            // this.alertText = "Saving Sizing Output to Database... Saved "+groupi+" of "+num_items;
            this.generatedAPIKey=response.data.generatedAPIKey;
        })
        .catch(error => {
          console.log("Batch- shareDatabases:", error);
            this.generatedAPIKey = "Error while generating API Key: "+error;
            // this.alertStyle="danger";
            // success=false;
        });
      
    }
  }  
  
};
</script>

<style>
</style>
